module.exports = __webpack_public_path__ + "pc/img/popup-img.c618789a.png";